import React, { Component } from 'react'
import Icon from './icon'
import './selector.css'

// Magical number, that's approximately the width of the text.
// (give we're not using a fixed width font it's approximate)
const selectWidth = label => label.length * 0.6 + 'em'

class GovActionToggleSelect extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.props.onChange('topic', event.target.value)
  }

  render() {
    const { options, value, icon, label } = this.props

    return (
      <div className="selector--wrapper">
        <Icon icon={icon} />

        <select
          name="topic"
          defaultValue={value}
          onChange={this.handleChange}
          style={{ maxWidth: selectWidth(label) }}>
          <option hidden>{label}</option>
          <optgroup label={label}>
            {options.map(({ label, value }, i) => (
              <option key={i} value={value}>
                {label}
              </option>
            ))}
          </optgroup>
        </select>
      </div>
    )
  }
}

export default GovActionToggleSelect



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/toggle-select.jsx